<template>
  <div>
    <b-card>
      <b-row class="mb-3">
        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">№</b>
            <b>#{{ instrument.id }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">{{$t('date')}}</b>
            <b>{{ $dayjs(instrument.created_at).format("DD.MM.YYYY") }}</b>
          </div>
        </b-col>

        <b-col
          v-if="instrument.status"
          class="col-md-2 ml-auto text-right"
        >

          <b-button
            v-for="(item, index) in instrument.status
              .change_to"
            :key="index"
            size="sm"
            class="ml-50"
            :variant="item.color"
            @click="onChangeStatus(instrument, item)"
          >
            {{ item.name }}
          </b-button>
        </b-col>
        <!-- <b-col class="col-md-2 ml-auto">
          <b-form-group
            :label="$t('status')"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="[]"
            />
          </b-form-group>
        </b-col> -->
      </b-row>


      <div class="mt-3">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <h4 class="mb-0">
            {{$t('sidebar.instrument')}}
          </h4>
        </div>
        <hr>

        <InstrumentTable :instrument="instrument" />
      </div>

      <div
        v-if="instrument.from_storage"
        class="d-flex align-items-center mt-3"
      >
        <div class="d-flex flex-column">
          <b class="mb-0">{{$t('where2')}}</b>
          <div>
            {{ instrument.from_storage.title }}
          </div>
        </div>

        <div
          v-if="instrument.to_storage"
          class="d-flex flex-column ml-5"
        >
          <b class="mb-0">{{$t('where')}}</b>
          <div>
            {{ instrument.to_storage.title }}
          </div>
        </div>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BCard,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import InstrumentTable from './tables/InstrumentTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    InstrumentTable,
  },
  data() {
    return {
      instrument: {},
    }
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('application', ['FETCH_ONE_APPLICATION_INSTRUMENT_RETURN', 'UPDATE_APPLICATION_INSTRUMENT_RETURN']),
    async refresh() {
      await this.FETCH_ONE_APPLICATION_INSTRUMENT_RETURN(this.$route.params.id)
      .then(res => {
        this.instrument = res
      })
    },
    onChangeStatus(props, item) {
      const status = {
        in_consideration: this.$t('submit_this_application_for_review'),
        confirmed: this.$t('confirm_this_application'),
        denied: this.$t('refuse_this_application'),
        accept_movement: this.$t('accept'),
      }
      this.$bvModal
        .msgBoxConfirm(
          this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t('attention'),
            size: 'sm',
            okVariant: item.color,
            okTitle: this.$t('yes'),
            cancelTitle: this.$t('no'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(async value => {
          if (!value) return
           this.UPDATE_APPLICATION_INSTRUMENT_RETURN({
            status_unique: item.unique_name,
            id: props.id,
          }).then(async () => {
            await this.refresh()
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
